import { useRef, useEffect, useCallback } from "react";

// This is a simple hook that allows component to check when they're unmounted, so they
// don't try to update their state when there's a callback that's run asynchronously, for
// example within a setTimeout callbacK.
//
export const useComponentIsUnmounted = () => {
  const isUnmounted = useRef(false);

  useEffect(
    () => () => {
      isUnmounted.current = true;
    },
    []
  );

  const fetchIsUnmounted = useCallback(() => isUnmounted.current, []);

  return fetchIsUnmounted;
};
